import { useIntl } from 'react-intl'
import { ProcessUpdate } from '@racepointenergy/swc/scs/types/host'

import formatBytes from 'app/utils/formatBytes'
import { closeAction } from './consts'
import { processMessages } from './messages'
import {
  ProcessInfoLabel,
  ProcessInfoNameLabel,
  ProcessInfoRowLabel,
  ProcessesRowActionIcon,
  ProcessesTableInfoItem,
  ProcessesTableInfoItemBodyItem,
  ProcessesTableInfoItemHeader,
  ProcessesTableInfoItemRow,
} from './styles'

interface ProcessInfoProps {
  value?: ProcessUpdate
  onClose: () => void
}

const ProcessInfoComponent = (props: ProcessInfoProps) => {
  const { formatMessage } = useIntl()
  const processInfo = props.value
  return (
    <ProcessesTableInfoItem>
      <ProcessesTableInfoItemHeader>
        <ProcessInfoLabel>
          {formatMessage(processMessages.processInfoLabel)}
        </ProcessInfoLabel>
        <ProcessesRowActionIcon
          size={16}
          src={closeAction.iconUrl}
          onClick={props.onClose}
        />
      </ProcessesTableInfoItemHeader>
      <ProcessesTableInfoItemRow>
        <ProcessInfoNameLabel>
          {processInfo?.ApplicationName}
        </ProcessInfoNameLabel>
      </ProcessesTableInfoItemRow>
      <ProcessesTableInfoItemRow>
        <ProcessInfoRowLabel>
          {formatMessage(processMessages.cpuUsageTitle)}
        </ProcessInfoRowLabel>
        <ProcessesTableInfoItemBodyItem>
          {processInfo?.CpuUsage?.toFixed(2)}
        </ProcessesTableInfoItemBodyItem>
      </ProcessesTableInfoItemRow>
      <ProcessesTableInfoItemRow>
        <ProcessInfoRowLabel>
          {formatMessage(processMessages.virtualMemoryTitle)}
        </ProcessInfoRowLabel>
        <ProcessesTableInfoItemBodyItem>
          {formatBytes(processInfo?.VirtualMemorySize)}
        </ProcessesTableInfoItemBodyItem>
      </ProcessesTableInfoItemRow>
      <ProcessesTableInfoItemRow>
        <ProcessInfoRowLabel>
          {formatMessage(processMessages.physicalMemoryTitle)}
        </ProcessInfoRowLabel>
        <ProcessesTableInfoItemBodyItem>
          {formatBytes(processInfo?.PhysicalMemorySize)}
        </ProcessesTableInfoItemBodyItem>
      </ProcessesTableInfoItemRow>
      <ProcessesTableInfoItemRow>
        <ProcessInfoRowLabel>
          {formatMessage(processMessages.pageFaultsTitle)}
        </ProcessInfoRowLabel>
        <ProcessesTableInfoItemBodyItem>
          {processInfo?.PageFaults}
        </ProcessesTableInfoItemBodyItem>
      </ProcessesTableInfoItemRow>
      <ProcessesTableInfoItemRow>
        <ProcessInfoRowLabel>
          {formatMessage(processMessages.processThreadsTitle)}
        </ProcessInfoRowLabel>
        <ProcessesTableInfoItemBodyItem>
          {processInfo?.ThreadCount}
        </ProcessesTableInfoItemBodyItem>
      </ProcessesTableInfoItemRow>
      <ProcessesTableInfoItemRow>
        <ProcessInfoRowLabel>
          {formatMessage(processMessages.processMessagesSent)}
        </ProcessInfoRowLabel>
        <ProcessesTableInfoItemBodyItem>
          {processInfo?.MessagesSent}
        </ProcessesTableInfoItemBodyItem>
      </ProcessesTableInfoItemRow>
      <ProcessesTableInfoItemRow>
        <ProcessInfoRowLabel>
          {formatMessage(processMessages.processMessagesReceived)}
        </ProcessInfoRowLabel>
        <ProcessesTableInfoItemBodyItem>
          {processInfo?.MessagesReceived}
        </ProcessesTableInfoItemBodyItem>
      </ProcessesTableInfoItemRow>
      <ProcessesTableInfoItemRow>
        <ProcessInfoRowLabel>
          {formatMessage(processMessages.processFileDescriptors)}
        </ProcessInfoRowLabel>
        <ProcessesTableInfoItemBodyItem>
          {processInfo?.FileDescriptors}
        </ProcessesTableInfoItemBodyItem>
      </ProcessesTableInfoItemRow>
      <ProcessesTableInfoItemRow>
        <ProcessInfoRowLabel>
          {formatMessage(processMessages.processVersion)}
        </ProcessInfoRowLabel>
        <ProcessesTableInfoItemBodyItem>
          {processInfo?.Version}
        </ProcessesTableInfoItemBodyItem>
      </ProcessesTableInfoItemRow>
      <ProcessesTableInfoItemRow>
        <ProcessInfoRowLabel>
          {formatMessage(processMessages.processBuild)}
        </ProcessInfoRowLabel>
        <ProcessesTableInfoItemBodyItem>
          {processInfo?.BuildNumber}
        </ProcessesTableInfoItemBodyItem>
      </ProcessesTableInfoItemRow>
    </ProcessesTableInfoItem>
  )
}

export default ProcessInfoComponent
